import { useRecoilValue } from 'recoil';

import { userInfo as userInfoAtom } from '../state/atoms';

export const UserMonthlyUsage = () => {
  const userInfo = useRecoilValue(userInfoAtom);

  const formatNumber = (num: number) => {
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}k`;
    }
    return num.toString();
  };

  const getResetUsageTime = () => {
    // Obtener la fecha actual en la zona horaria de Los Ángeles
    const nowLA = new Date().toLocaleString('en-US', {
      timeZone: 'America/Los_Angeles',
    });
    const now = new Date(nowLA);

    // Calcular el próximo 1º del mes a las 00:00 en Los Ángeles
    const nextReset = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    const nextResetLA = new Date(
      nextReset.toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
      })
    );

    const diffTime = nextResetLA.getTime() - now.getTime();
    const diffHours = diffTime / (1000 * 60 * 60);

    if (diffHours < 24) {
      return 'tomorrow';
    }

    const diffDays = Math.ceil(diffHours / 24);
    return `${diffDays} days`;
  };

  return (
    <div className="flex-none bg-nav">
      {userInfo.current_usage !== undefined &&
        userInfo.limit_usage !== undefined && (
          <div className="">
            <div className="mb-2">
              <div className="flex justify-between text-sm text-gray-600 mb-1">
                <span>Usage</span>
                <span>
                  {formatNumber(userInfo.current_usage)}/
                  {formatNumber(userInfo.limit_usage)}
                </span>
              </div>
              <div className="w-full bg-lightBlue rounded-full h-2">
                <div
                  className="bg-skyBlue h-2 rounded-full transition-all duration-300"
                  style={{
                    width: `${Math.min(
                      (userInfo.current_usage / userInfo.limit_usage) * 100,
                      100
                    )}%`,
                  }}
                ></div>
              </div>
            </div>
            <div className="text-xs text-gray-500">
              Usage resets in {getResetUsageTime()}
            </div>
          </div>
        )}
    </div>
  );
};
